
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import RelatedServices from '../components/RelatedServices';
import FAQKeyword from './FAQKeyword';

function Amrutatravelspune() {



    const cardData =
    {
        keyword: 'Amruta Travels',
        heading: 'Amruta Travels Pune – Official Bus Rental & Group Travel Partner',
        headingDescription: 'Welcome to Amruta Travels, one of Pune’s trusted names for bus rental, Tempo Traveller hire, Force Urbania rental and group transportation services. Since our inception, we have helped thousands of families, corporate clients, educational institutions and tourists travel safely and comfortably across Pune, Maharashtra and major outstation destinations. Whether you need a luxury Force Urbania, Tempo Traveller, corporate bus, wedding transportation or pilgrimage tour, Amruta Travels offers well-maintained vehicles, experienced chauffeurs, transparent pricing and 24×7 customer support. Our commitment to punctuality, passenger safety and customer satisfaction has made Amruta Travels a preferred choice for local as well as outstation group travel.',
        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



    "services": [
    {
      "name": "Amruta Travels Pune",
      "description": "Reliable travel service in Pune offering bus rentals, city tours, outstation travel, and corporate transportation with professional drivers."
    },
    {
      "name": "Amruta Travels Pune contact number",
      "description": "Contact Amruta Travels Pune for inquiries, bookings, and travel assistance."
    },
    {
      "name": "Amruta Travels Pune phone number",
      "description": "Phone number for Amruta Travels Pune to get instant information and bookings for buses and tours."
    },
    {
      "name": "Amruta Travels Pune address",
      "description": "Official address of Amruta Travels Pune for office visits and direct bookings."
    },
    {
      "name": "Amruta Travels Pune reviews",
      "description": "Customer reviews and ratings of Amruta Travels Pune for bus hire, tours, and services."
    },
    {
      "name": "Amruta Travels Pune Bus booking",
      "description": "Book buses online or offline from Amruta Travels Pune for city, outstation, or pilgrimage tours."
    },
    {
      "name": "Amruta Travels bus rental Pune",
      "description": "Bus rental service in Pune by Amruta Travels for family trips, corporate events, and group travel."
    },
    {
      "name": "Amruta Travels Urbania bus Pune",
      "description": "Urbania bus hire in Pune by Amruta Travels for small groups, corporate travel, and VIP transportation."
    },
    {
      "name": "Amruta Travels Force Urbania Pune",
      "description": "Force Urbania bus hire service in Pune by Amruta Travels for comfortable group travel and outstation trips."
    },
    {
      "name": "Amruta Travels bus on rent Pune",
      "description": "Bus on rent service in Pune for city tours, outstation trips, and airport transfers."
    },
    {
      "name": "Amruta Travels bus hire Pune",
      "description": "Bus hire service in Pune by Amruta Travels for weddings, corporate events, sightseeing, and family trips."
    },
    {
      "name": "Amruta Travels luxury bus Pune",
      "description": "Luxury bus hire in Pune offering premium AC coaches, plush seating, and experienced drivers for outstation and corporate travel."
    },
    {
      "name": "Amruta Travels Urbania bus on rent Pune",
      "description": "Urbania bus on rent in Pune for corporate travel, airport transfers, and family trips."
    },
    {
      "name": "Amruta Travels 13 seater Urbania Pune",
      "description": "13 seater Urbania bus from Amruta Travels Pune for small groups and family outings."
    },
    {
      "name": "Amruta Travels 17 seater Urbania Pune",
      "description": "17 seater Urbania bus hire for larger groups, corporate outings, and outstation travel."
    },
    {
      "name": "Amruta Travels AC bus Pune",
      "description": "AC bus rental in Pune for comfortable city and outstation travel."
    },
    {
      "name": "Amruta Travels luxury Urbania bus Pune",
      "description": "Luxury Urbania bus from Amruta Travels Pune for VIP travel, corporate trips, and family excursions."
    },
    {
      "name": "Amruta Travels Pune to Ashtavinayak",
      "description": "Pune to Ashtavinayak Darshan bus service by Amruta Travels with AC Urbania buses for day and multi-day trips."
    },
    {
      "name": "Amruta Travels Pune to Shirdi",
      "description": "Pune to Shirdi bus service by Amruta Travels with comfortable AC buses for pilgrimage and family trips."
    },
    {
      "name": "Amruta Travels Pune Darshan bus",
      "description": "Darshan bus services in Pune for local and nearby temple visits including Ashtavinayak, Shirdi, and Ganpati temples."
    },
    {
      "name": "Amruta Travels Pune sightseeing tour",
      "description": "Sightseeing bus tours in Pune by Amruta Travels covering major city attractions with professional drivers and AC buses."
    },
    {
      "name": "Amruta Travels Pune outstation bus hire",
      "description": "Outstation bus hire in Pune for Lonavala, Mahabaleshwar, Shirdi, and other destinations with AC and luxury buses."
    },
    {
      "name": "Amruta Travels corporate bus hire Pune",
      "description": "Corporate bus hire service in Pune by Amruta Travels for office staff transport, client visits, and company outings."
    },
    {
      "name": "Amruta Travels bus for corporate events Pune",
      "description": "Bus service for corporate events and meetings in Pune with professional drivers and luxury buses."
    },
    {
      "name": "Amruta Travels office staff transport Pune",
      "description": "Bus hire service for office staff in Pune with punctual and safe transport from Amruta Travels."
    },
    {
      "name": "Amruta Travels company outing bus Pune",
      "description": "Company outing bus hire in Pune by Amruta Travels with comfortable AC buses for team trips and excursions."
    },
    {
      "name": "Amruta Travels Pune bus rental price",
      "description": "Affordable and transparent bus rental pricing in Pune by Amruta Travels for various services."
    },
    {
      "name": "Amruta Travels Pune Urbania bus rate",
      "description": "Rates for Urbania bus hire in Pune by Amruta Travels for local, airport, and outstation travel."
    },
    {
      "name": "Amruta Travels Pune bus hire per km",
      "description": "Per km bus hire rates in Pune by Amruta Travels for economical group travel."
    },
    {
      "name": "Amruta Travels Pune affordable bus hire",
      "description": "Budget-friendly bus rental service in Pune by Amruta Travels without compromising on comfort and AC facilities."
    },
    {
      "name": "Top Rated Amruta Travels Pune",
      "description": "Highly rated Amruta Travels Pune for bus rentals, Urbania services, and corporate travel."
    },
    {
      "name": "Amruta Travels Pune Urbania Bus Hire",
      "description": "Urbania bus hire service in Pune by Amruta Travels for family trips, corporate travel, and VIP transport."
    },
    {
      "name": "Amruta Travels Pune Luxury Bus Rentals",
      "description": "Luxury bus rentals in Pune for corporate, family, and pilgrimage trips with premium AC buses."
    },
    {
      "name": "Amruta Travels Pune to Ashtavinayak Bus",
      "description": "Dedicated Pune to Ashtavinayak Darshan bus service by Amruta Travels with Urbania and AC buses."
    }
  ],
  "tableData": [
    ["Amruta Travels Pune", "Amruta Travels Pune contact number"],
    ["Amruta Travels Pune phone number", "Amruta Travels Pune address"],
    ["Amruta Travels Pune reviews", "Amruta Travels Pune Bus booking"],
    ["Amruta Travels bus rental Pune", "Amruta Travels Urbania bus Pune"],
    ["Amruta Travels Force Urbania Pune", "Amruta Travels bus on rent Pune"],
    ["Amruta Travels bus hire Pune", "Amruta Travels luxury bus Pune"],
    ["Amruta Travels Urbania bus on rent Pune", "Amruta Travels 13 seater Urbania Pune"],
    ["Amruta Travels 17 seater Urbania Pune", "Amruta Travels AC bus Pune"],
    ["Amruta Travels luxury Urbania bus Pune", "Amruta Travels Pune to Ashtavinayak"],
    ["Amruta Travels Pune to Shirdi", "Amruta Travels Pune Darshan bus"],
    ["Amruta Travels Pune sightseeing tour", "Amruta Travels Pune outstation bus hire"],
    ["Amruta Travels corporate bus hire Pune", "Amruta Travels bus for corporate events Pune"],
    ["Amruta Travels office staff transport Pune", "Amruta Travels company outing bus Pune"],
    ["Amruta Travels Pune bus rental price", "Amruta Travels Pune Urbania bus rate"],
    ["Amruta Travels Pune bus hire per km", "Amruta Travels Pune affordable bus hire"],
    ["Top Rated Amruta Travels Pune", "Amruta Travels Pune Urbania Bus Hire"],
    ["Amruta Travels Pune Luxury Bus Rentals", "Amruta Travels Pune to Ashtavinayak Bus"]
  ],


  

"whychoose": [
  {
    "WhyChooseheading": "Trusted Travel Services with Amruta Travels Pune",
    "WhyChoosedescription": "Amruta Travels Pune offers reliable, comfortable, and stylish travel solutions for corporate events, family outings, group trips, and city tours with a fleet of well-maintained vehicles."
  },
  {
    "WhyChooseheading": "Comprehensive Travel Solutions",
    "WhyChoosedescription": "From airport transfers and city sightseeing to long-distance trips and special events, Amruta Travels Pune ensures convenient and hassle-free travel for all types of journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Premium Vehicles",
    "WhyChoosedescription": "Our fleet includes Urbania luxury mini buses and other vehicles with spacious seating, air conditioning, and ample luggage space, providing a comfortable travel experience for groups of all sizes."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "All our drivers are experienced, courteous, and knowledgeable about Pune’s routes and destinations, ensuring a safe, smooth, and enjoyable journey."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels Pune offers competitive and transparent pricing for all travel services, providing excellent value without hidden charges."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "We maintain the highest standards of hygiene, safety, and comfort, with all vehicles regularly serviced and sanitized for your peace of mind."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Routes",
    "WhyChoosedescription": "We provide flexible pickup and drop-off locations and customizable routes to meet your specific travel needs across Pune and nearby destinations."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking with Full Support",
    "WhyChoosedescription": "Booking with Amruta Travels Pune is quick and simple. Our dedicated support team assists you at every step to ensure a smooth and enjoyable travel experience."
  }
]

    }

const faqData = [
  {
    question: 'What services does Amruta Travels Pune offer?',
    answer: 'Amruta Travels Pune provides vehicle rentals for corporate events, family trips, city tours, airport transfers, and long-distance travel with comfortable and reliable vehicles.'
  },
  {
    question: 'What types of vehicles are available with Amruta Travels Pune?',
    answer: 'We offer a fleet of vehicles including Urbania luxury mini buses and other options suitable for group travel, corporate trips, and family outings.'
  },
  {
    question: 'Are the vehicles maintained and clean?',
    answer: 'Yes, all vehicles are regularly serviced, cleaned, and sanitized to ensure the highest standards of safety, comfort, and hygiene.'
  },
  {
    question: 'Do Amruta Travels Pune rentals include a driver?',
    answer: 'Yes, every vehicle rental includes a professional and courteous driver who ensures a safe and comfortable journey.'
  },
  {
    question: 'How can I book a vehicle with Amruta Travels Pune?',
    answer: 'You can book vehicles online, via phone, or by visiting our office. Our team will assist you in choosing the right vehicle and planning your trip.'
  },
  {
    question: 'What is the pricing for Amruta Travels Pune services?',
    answer: 'Pricing depends on the type of vehicle, trip duration, and distance. Contact us for a customized and transparent quote.'
  },
  {
    question: 'Can I customize pickup, drop-off, and routes?',
    answer: 'Yes, we provide flexible pickup and drop-off options and customizable routes to suit your travel requirements across Pune.'
  },
  {
    question: 'Why choose Amruta Travels Pune?',
    answer: 'Amruta Travels Pune offers well-maintained vehicles, professional drivers, transparent pricing, and dedicated support to ensure a comfortable, reliable, and hassle-free travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sameer Joshi',
    role: 'Corporate Client, Pune',
    text: 'Amruta Travels Pune provided excellent service for our corporate team outing. The vehicle was comfortable, the driver punctual and professional. Highly recommend them!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Kavita Patil',
    role: 'Family Traveler, Pune',
    text: 'We hired a vehicle from Amruta Travels Pune for a family trip. The experience was seamless and enjoyable, with a clean vehicle and courteous driver.',
    rating: 5
  }
];































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
{
    src: "/images/gallery/24.jpg",
    alt: "Amruta Travels Bus Rental in Pune",
    title: "Amruta Travels Bus Rental",
    caption: "Premium bus rental services in Pune for weddings, corporate events and group travel."
},
{
    src: "/images/gallery/28.jpg",
    alt: "Tempo Traveller Hire by Amruta Travels",
    title: "Tempo Traveller Hire Pune",
    caption: "Comfortable Tempo Traveller rental for family trips and outstation tours."
},
{
    src: "/images/gallery/2.jpg",
    alt: "Force Urbania Rental Pune",
    title: "Force Urbania on Rent",
    caption: "Luxury Force Urbania rental for executive travel and family vacations."
},
{
    src: "/images/gallery/3.jpg",
    alt: "Corporate Bus Service Pune",
    title: "Corporate Transportation",
    caption: "Reliable employee transportation and corporate travel solutions."
},
{
    src: "/images/gallery/24.jpg",
    alt: "Wedding Bus Rental Pune",
    title: "Wedding Transportation",
    caption: "Comfortable transportation for wedding guests and family members."
},
{
    src: "/images/gallery/27.jpg",
    alt: "Airport Transfer Pune",
    title: "Airport Transfer Service",
    caption: "Professional airport pickup and drop services in Pune."
},
{
    src: "/images/gallery/29.jpg",
    alt: "Outstation Bus Hire Pune",
    title: "Outstation Tours",
    caption: "Outstation travel to Shirdi, Goa, Lonavala, Mahabaleshwar and more."
},
{
    src: "/images/gallery/30.jpg",
    alt: "Luxury Bus Rental Pune",
    title: "Luxury Bus Hire",
    caption: "Luxury buses for business events, tours and VIP transportation."
},
{
    src: "/images/gallery/31.jpg",
    alt: "Amruta Travels Fleet",
    title: "Our Fleet",
    caption: "Modern fleet of buses, Tempo Travellers and Force Urbania vehicles."
}
];




const amrutaTravelsSchema = {
  "@context": "https://schema.org",
  "@type": "TravelAgency",
  "name": "Amruta Travels",
  "image": "https://bushireinpune.com/images/logo.png",
  "url": "https://bushireinpune.com",
  "telephone": "+91 7353109555",
  "email": "booking@bushireinpune.com",
  "description": "Amruta Travels is a trusted travel agency in Pune offering Bus Rental, Tempo Traveller Hire, Force Urbania Rental, Corporate Transportation, Wedding Transportation, Airport Transfers and Outstation Tours across Maharashtra.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Office No.-2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Vadgaon Budruk",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411041",
    "addressCountry": "IN"
  },
  "sameAs": [
    "https://www.facebook.com/amrutatravels",
    "https://www.instagram.com/bushireinpune",
    "https://www.linkedin.com/company/bus-hire-in-pune"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1500"
  },
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 06:00-22:00"
};







    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Amruta Travels Pune | Luxury Urbania & Bus Rentals in Pune</title>
  <meta
    name="description"
    content="Amruta Travels Pune offers 13 & 17 seater Urbania bus rentals, luxury & AC buses for family trips, corporate events, Pune Darshan, Shirdi & Ashtavinayak tours. Affordable rates & professional drivers."
  />
  <script type="application/ld+json">
    {JSON.stringify(amrutaTravelsSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img
    src="/images/keyword/124.jpg"
    alt="Amruta Travels Pune"
    title="Amruta Travels Pune | Official Website"
    loading="eager"
    className="img-fluid"
/>
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>

                                <div className="mt-5">

<h2 className="darkcolorrr mb-4">
About Amruta Travels
</h2>

<p>
Amruta Travels is a trusted travel and transportation company based in Pune, specializing in premium bus rental, Tempo Traveller hire, Force Urbania rental, corporate transportation, wedding travel, airport transfers, school trips and outstation tours. We are committed to providing safe, comfortable and reliable travel experiences with a fleet of well-maintained vehicles and professionally trained chauffeurs.
</p>

<p>
Over the years, Amruta Travels has earned the trust of families, corporate organizations, educational institutions, travel planners and tourists by delivering punctual service, transparent pricing and exceptional customer support. Whether you need transportation for a small family trip or a large corporate event, we offer customized travel solutions designed around your requirements.
</p>

</div>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="mt-5">

<h2 className="darkcolorrr mb-4">
Our Travel Services
</h2>

<p>
Amruta Travels offers complete travel solutions for individuals, families, corporate organizations, educational institutions and tourists across Pune and Maharashtra. From luxury vehicle rentals to corporate transportation, we provide customized travel services for every occasion.
</p>

<div className="row mt-4">

<div className="col-md-6">

<h4 className="darkcolorrr">
Bus Rental in Pune
</h4>

<p>
AC and Non-AC buses for weddings, corporate events, school trips, sightseeing, family functions and outstation travel.
</p>

<h4 className="darkcolorrr mt-4">
Tempo Traveller Hire
</h4>

<p>
Comfortable Tempo Travellers for family vacations, corporate outings, airport transfers and pilgrimage tours.
</p>

<h4 className="darkcolorrr mt-4">
Force Urbania Rental
</h4>

<p>
Premium Force Urbania vehicles for executive travel, VIP guests, weddings and family trips.
</p>

</div>

<div className="col-md-6">

<h4 className="darkcolorrr">
Corporate Transportation
</h4>

<p>
Daily employee transportation, conferences, exhibitions, airport transfers and company outings.
</p>

<h4 className="darkcolorrr mt-4">
Wedding Transportation
</h4>

<p>
Comfortable transportation for wedding guests and family members across Pune and nearby destinations.
</p>

<h4 className="darkcolorrr mt-4">
Outstation Tours
</h4>

<p>
Customized trips to Shirdi, Lonavala, Mahabaleshwar, Goa, Mumbai, Nashik and Ashtavinayak.
</p>

</div>

</div>

<div
    style={{
        cursor: 'pointer',
        padding: '10px',
        marginBottom: '7px',
        borderRadius: '8px',
        transition: 'transform 0.2s'
    }}
>
    {cardData.services.map((service, index) => (
        <div key={index} className=" my-4">
            <h4 className="py-1 darkcolorrr">{service.name}</h4>
            <p>{service.description}</p>
        </div>
    ))}
</div>

</div>

                            <div className="mt-5">

<h2 className="darkcolorrr mb-4">
Our Commitment to Quality
</h2>

<p>
At Amruta Travels, every journey is planned with safety, comfort and reliability in mind. We believe quality transportation is about more than providing a vehicle—it is about delivering a dependable experience from booking through to your destination. Our dedicated team focuses on punctual service, well-maintained vehicles and responsive customer support to ensure every trip meets our customers' expectations.
</p>

<div className="row mt-4">

<div className="col-md-6">

<ul>

<li>Professional & Verified Drivers</li>

<li>Regular Vehicle Maintenance</li>

<li>Clean & Sanitized Fleet</li>

<li>Transparent Pricing</li>

<li>24×7 Booking Support</li>

</ul>

</div>

<div className="col-md-6">

<ul>

<li>Local & Outstation Travel</li>

<li>Corporate Travel Specialists</li>

<li>Wedding Transportation Experts</li>

<li>Flexible Booking Options</li>

<li>Trusted by Families & Businesses</li>

</ul>

</div>

</div>

</div>

<table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <RelatedServices page="brand" />

<TestimonialKeyword
    title="Testimonial"
    description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
    reviews={testimonialsData}
/>

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
    src={image.src}
    alt={image.alt}
    title={image.title}
    loading="lazy"
    className="gallery-image"
/>

<p className="text-center mt-2 small text-muted">
    {image.caption}
</p>
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Amrutatravelspune;